import firebase, {fc} from './connection'
import store from '../store.js'
import router from '../router.js'


export default {
    send(payload) {
        let sendContact = fc.httpsCallable('sendMail');
        
        return sendContact({name: payload.name, email: payload.email, services: payload.services})
                    .then(response => {
                        if (response.data === true) {
                            return true;
                        } else {
                            return response;
                        }
                    })
                    .catch(error => {
                        return error;
                    });
}
}